/*eslint-disable*/
import axios from 'axios';
import {baseApiUrl} from "../../../config.js";
import { loadModules } from 'esri-loader';

const state = {
  mapWebScene: null,
  mapView: null,
  initialIssues: [],
  issueComments: [],
  currentIssueId: null,
  currentIssue: null,
  currentComments: [],
  userName: null,
  user: null,
  commentAttachments: [],
  staticIssueLayerId: "issue-graphics",
  staticIssueLayerTitle: "User Issues",
  mapWebSceneLoadFlag: null,
  isAddNewIssue: false,
  userList: []
}

function initialState() {
  return {
    mapWebScene: null,
    mapView: null,
    initialIssues: [],
    issueComments: [],
    currentIssueId: null,
    currentIssue: null,
    currentComments: [],
    userName: null,
    user: null,
    commentAttachments: [],
    staticIssueLayerId: "issue-graphics",
    staticIssueLayerTitle: "User Issues",
    mapWebSceneLoadFlag: null,
    isAddNewIssue: false,
    userList: []
  }
}
const mutations = {
  saveMapWebScene(state, data) {
    state.mapWebScene = data
  },
  saveMapView(state, data) {
    state.mapView = data
  },
  saveUserName(state, data) {
    state.userName = data
  },
  saveUser(state, data) {
    state.user = data
  },
  insertUserList(state, data){
    state.userList = data
  },
  insertInitialIssues(state, payload) {
    console.log("insertInitialIssues");
    console.log(payload);
    state.initialIssues.push(payload)
  },
  resetInitialIssues(state) {
    state.initialIssues = []
  },
  resetIssueComments(state) {
    state.issueComments = []
  },
  insertIssueComments(state, payload) {
    state.issueComments.push(payload)
  },
  setCurrentIssueId(state, payload) {
    state.currentIssueId = payload
  },
  setCurrentIssue(state, payload) {
    state.currentIssue = payload
  },
  setCurrentComments(state, payload) {
    payload.comments.forEach(item=>{
      state.currentComments.push(item)
    })
  },
  clearCurrentComments(state) {
    state.currentComments = []
  },
  addNewComment(state, payload) {
    var objectId = payload.objectId
    var currentComments = state.issueComments.filter(obj=>obj.objectId == objectId)
    if (currentComments.length) {
      currentComments[0].comments.push(payload.comment)
    }
    else {
      var issueComment = {
        decision: payload.decision,
        approvalStateCode: payload.approvalStateCode,
        objectId: objectId,
        comments: [payload.comment]
      }
      console.log(issueComment);
      state.issueComments.push(issueComment)
    }
  },
  finalizeIssue(state, payload) {
    var currentIssue = state.initialIssues.filter(obj=>obj.objectId == payload.objectId)
    currentIssue[0].approvalStatus = payload.decision?"Approved":currentIssue.approvalStatus
    console.log(currentIssue);
  },
  clearAttachments(state) {
    state.commentAttachments = []
  },
  addAttachment(state, payload) {
    state.commentAttachments.push(payload)
  },
  removeAttachment(state, index) {
    state.commentAttachments.splice(index,1)
  },
  setMapWebSceneLoadFlag(state, payload) {
    state.mapWebSceneLoadFlag = payload
  },
  setIfAddNewIssueClicked(state, payload){
    state.isAddNewIssue = payload
  },
}

const actions = {
  async fetchIssueComments ({commit, dispatch}, payload) {
    return new Promise(function(resolve, reject) {
      let url = baseApiUrl + "fetchComments"
      let data    = {
        issueIds: payload.objectIds
      }
      let config  = {
        responseType: 'json'
      }
      axios.post(url, data, config).then((result)=>{
        commit("resetIssueComments")
        result.data.forEach((item,index) => {
          commit('insertIssueComments', item);
        })
        resolve();
      }).catch(error=>{
        reject(error);
      })
    })
  },
  setCurrentIssueDetails({state, commit}, payload) {
    commit("setCurrentIssueId", payload)
    var currentIssue = state.initialIssues.filter(obj=>obj.objectId == payload)
    console.log(currentIssue);
    if (currentIssue.length) {
      commit("setCurrentIssue", currentIssue)
    }
    var currentComments = state.issueComments.filter(obj=>obj.objectId == payload)
    commit("clearCurrentComments")
    if (currentComments.length) {
      commit("setCurrentComments", currentComments[0])
    }
    console.log("Current Issue: ");
    console.log(state.currentIssue);
    console.log("Current Comments: ");
    console.log(state.currentComments);
  },
  fetchIssueLayer({commit, dispatch}, payload) {
    return new Promise(function(resolve, reject) {
      // const vue = document.getElementById("map").__vue__
      // const view = vue.view
      var url = baseApiUrl + "fetchIssues"
      var data = {}
      var config = {
        responseType: 'json'
      }
      axios.post(url, data, config).then(response=>{
        var issuesList = response.data.features
        console.log(issuesList);
        var issuesCount = 0;
        loadModules([
          "esri/layers/GraphicsLayer",
          "esri/Graphic",
          "esri/PopupTemplate"
        ],{ css: true })
        .then(([
          GraphicsLayer,
          Graphic,
          PopupTemplate
        ]) => {
          const issueGraphicsLayer = new GraphicsLayer({
            id: state.staticIssueLayerId,
            title: state.staticIssueLayerTitle
          });
          const popupTemplate = new PopupTemplate({
            title: "Issue Details",
            content: [{
              type: "fields",
              fieldInfos: [
                {
                  fieldName: "id",
                  label: "Object ID"
                },
                {
                  fieldName: "issueCreatedBy",
                  label: "Created by"
                },
                {
                  fieldName: "requestDetails",
                  label: "Request"
                },
                {
                  fieldName: "issueType",
                  label: "Type"
                },
                {
                  fieldName: "requestCreated",
                  label: "Request Created"
                },
                {
                  fieldName: "date",
                  label: "Date"
                },
                {
                  fieldName: "approvalState",
                  label: "Approval Status"
                },
                {
                  fieldName: "priority",
                  label: "Priority"
                }
              ]
            }]
          });
          // for (const issue of issuesList) {
          issuesList.forEach(issue=>{
            var issueEntry = new Graphic({
              geometry: {
                type: "point",
                latitude: issue.geometry.latitude,
                longitude:issue.geometry.longitude,
                z: issue.geometry.height
              },
              attributes: issue.attributes,
              symbol: {
                type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                url: "DefaultMarker.png",
                width: 20
                // type: "point-3d",
                // symbolLayers: [{
                //   type: "object",
                //   anchor: "origin",
                //   width: 5,
                //   material: {
                //     color: [198, 235, 52, 1]
                //   }
                // }]
              },
              popupTemplate: popupTemplate
            });

            issueGraphicsLayer.graphics.push(issueEntry)

          })
          resolve(issueGraphicsLayer)
        })
      })
    });
  }
}

const getters = {}



export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
